import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import { getCustomState } from '../../../util/LocalStorage';
import { USER_DATA, USER_ROLES } from '../../../util/constants/AppConstants';

import Logo from '../../../assets/images/logo.png';
import './Sidebar.scss';

const Sidebar = ({ isOpen, setIsOpen, menuRef }) => {
  const [userInfo, setUserInfo] = useState(null);

  const sessionRedux = useSelector((state) => state.session.session);

  const navigate = useNavigate();

  const { pathname } = useLocation();

  const mppRoleValue = USER_ROLES.find((role) => role.short === 'MPP').value;
  const councillorRoleValue = USER_ROLES.find((role) => role.short === 'Councillor').value;

  const isMpp = userInfo && userInfo.role === mppRoleValue;
  const isCouncillor = userInfo && userInfo.role === councillorRoleValue;

  useEffect(() => {
    setUserInfo(getCustomState(USER_DATA, true));
  }, [sessionRedux]);

  const handleNavigate = (pathname) => {
    navigate(pathname);
    setIsOpen(false);
  };

  const handleLogoClick = () => {
    handleNavigate(isMpp || isCouncillor ? '/activity_map' : '/emails');
  };

  return (
    <div className={`sidebar ${isOpen ? 'open' : ''}`} ref={menuRef}>
      <div className="sidebar__logo" onClick={handleLogoClick}>
        <img src={Logo} alt="TAGA" />
      </div>
      <div className="sidebar__tabs">
        <div
          className={`sidebar__tab ${pathname === '/activity_map' ? 'active' : ''}`}
          onClick={() => handleNavigate('/activity_map')}
        >
          Activity Map
        </div>
        <div
          className={`sidebar__tab ${pathname === '/constituents' ? 'active' : ''}`}
          onClick={() => handleNavigate('/constituents')}
        >
          Constituents
        </div>
        <div
          className={`sidebar__tab ${pathname === '/cases' ? 'active' : ''}`}
          onClick={() => handleNavigate('/cases')}
        >
          Cases
        </div>
        <div
          className={`sidebar__tab ${pathname === '/files' ? 'active' : ''}`}
          onClick={() => handleNavigate('/files')}
        >
          Files
        </div>
        <div
          className={`sidebar__tab ${pathname === '/emails' ? 'active' : ''}`}
          onClick={() => handleNavigate('/emails')}
        >
          Emails
        </div>
        <div
          className={`sidebar__tab ${pathname === '/pending_emails' ? 'active' : ''}`}
          onClick={() => handleNavigate('/pending_emails')}
        >
          Pending Emails
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
